/*
 *
 * VetrinaDigitaleSubmitPopup
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 04-Feb-2025
*/

import { connect } from 'react-redux'
import { nullSafe } from 'Utility/globalMethods'
// import { bindActionCreators } from 'redux'

import VetrinaDigitaleSubmitPopup from './VetrinaDigitaleSubmitPopup'

const mapDispatchToProps = dispatch => ({

})

const mapStateToProps = (state) => ({
  redirectUrl: nullSafe(() => state.VetrinaDigitale.redirectUrl, {})
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(VetrinaDigitaleSubmitPopup)
